import React from "react";
import "./InputTextarea.scss";

type InputTextareaProps = {
    label?: string;
    placeholder?: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    disabled?: boolean;
    error?: boolean;
    rows?: number;
    className?: string;
};

const InputTextarea: React.FC<InputTextareaProps> = ({
    label,
    placeholder = "Escribe aquí...",
    value,
    onChange,
    disabled = false,
    error = false,
    rows = 4,
    className = "",
}) => {
    return (
        <div className={`input-textarea-container ${className}`}>
            {label && <label className="input-textarea-label">{label}</label>}
            <textarea
                className={`input-textarea ${error ? "error" : ""}`}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                disabled={disabled}
                rows={rows}
            />
            {error && (
                <p className="input-textarea-error">
                    Este campo es obligatorio
                </p>
            )}
        </div>
    );
};

export default InputTextarea;
